import { api } from '@/shared/axios-client';

const METHOD_OR_FUNCTION_TYPES = new Set(['method', 'function']);

/** True when entity `type` is Method or Function (scanEntities convention). */
export function isMethodOrFunctionEntity(type: string | null | undefined): boolean {
  const normalized = String(type ?? '')
    .trim()
    .toLowerCase();
  return METHOD_OR_FUNCTION_TYPES.has(normalized);
}

export type TestcaseCoveredEntity = {
  entityId?: string;
  name?: string;
  type?: string;
  signature?: string;
  lineStart?: number;
  lineEnd?: number;
  entityKey?: string;
  parentEntityId?: string;
  depth?: number;
  hitLinesCount?: number;
};

export type TestcaseCoveredFile = {
  filePath?: string;
  coveredLinesCount?: number;
  entitiesHitCount?: number;
  entities?: TestcaseCoveredEntity[];
};

export type TestcaseEntitiesCoveredData = {
  scanId?: string;
  testCaseName?: string;
  sessionId?: string;
  sourceType?: string;
  files?: TestcaseCoveredFile[];
  error?: string;
};

export interface TestcaseEntitiesCoveredServiceResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data: TestcaseEntitiesCoveredData | null;
}

export async function getTestcaseEntitiesCovered(
  scanId: string,
  testCaseName: string,
): Promise<TestcaseEntitiesCoveredServiceResponse> {
  const res = (await api.post('/api/testcase/entities-covered', {
    scanId: scanId.trim(),
    testCaseName: testCaseName.trim(),
  })) as TestcaseEntitiesCoveredServiceResponse;
  return res;
}



